import { PencilSquareIcon } from '@shared/assets/icons';
import { EditIAdditionalGuestModal } from '@features/clients';
import { UnstyledButton } from '@shared/ui/unstyled-button';
import { useState } from 'react';
import styles from './styles.module.scss';
import { AdditionalGuestUpdate, ClientInfo, SminexClubAdditional } from '@entities/clients';
import clsx from 'clsx';

interface AdditionalGuestCellProps {
  clientInfo: ClientInfo;
  onChangeAdditionalGuest: (value: AdditionalGuestUpdate[]) => void;
  additionalGuest: SminexClubAdditional[];
}

export const AdditionalGuestCell = ({
  clientInfo,
  onChangeAdditionalGuest,
  additionalGuest,
}: AdditionalGuestCellProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { FIO } = clientInfo;

  return (
    <>
      <div className={styles.container}>
        <UnstyledButton className={styles.editButton} onClick={() => setIsModalOpen(true)}>
          <span className={styles.editButtonContent}>
            <PencilSquareIcon size="16" color="currentColor" />
            Редактировать
          </span>
        </UnstyledButton>

        <div className={styles.items}>
          {additionalGuest.length
            ? additionalGuest.map(({ id, fio, checked }) => (
                <div key={id} className={styles.item}>
                  <div className={clsx(styles.mark, checked && styles.checked)} />
                  <span className={styles.visuallyHidden}>{checked ? 'Пришёл' : 'Не пришёл'}</span>
                  <span>{fio}</span>
                </div>
              ))
            : '—'}
        </div>
      </div>

      {isModalOpen && (
        <EditIAdditionalGuestModal
          onClose={() => setIsModalOpen(false)}
          onSave={onChangeAdditionalGuest}
          additionalGuest={additionalGuest}
          participantName={FIO}
        />
      )}
    </>
  );
};
